module.exports = __webpack_public_path__ + "static/media/frameshop_4.aa4dca11.jpg";